<template>
  <w-schema :model="model">
    <v-radio-group :label="model.$title">
      <v-radio v-for="(element, index) in elements" :key="index" :label="element.text" :value="element.value" />
    </v-radio-group>
  </w-schema>
</template>

<script>
import { WSchema } from '@witkac/vuetify-components';

// @vuese
// Grupa radio
// @group forms
export default {
  components: { WSchema },
  props: {
    // Model
    model: { type: Object, required: true },
    // Elementy
    elements: { type: Array, default: () => [{ value: 'false', text: 'Nie' }, { value: 'true', text: 'Tak' }] }
  }
};
</script>
